const isKalamanchWebHost = typeof window !== 'undefined' && /(^|\.)kalamanch\.art$/i.test(window.location.hostname);

export const BACKEND_BASE_URL = isKalamanchWebHost ? '' : (process.env.REACT_APP_BACKEND_URL || '');
export const API_BASE_URL = `${BACKEND_BASE_URL}/api`;
